import React from 'react'
import Background from 'components/Background'

const TransactionsViewBackground = () => (
  <Background height="48vh" />
)
export default TransactionsViewBackground
